export default __webpack_public_path__ + "static/media/burpcert.b2aeffcb.png";